<template>
  <div>
    <b-notification :has-icon="true" icon="info" :closable="false">
      <p v-html="$t('compCarbonFormsFoodsHelpManual.text-1')" />
    </b-notification>
    <help-data />
  </div>
</template>

<script>
export default {
  name: 'HelpManual',
  components: {
    'help-data': () => import('@/components/carbon/forms/foods/HelpData.vue')
  }
}
</script>
